"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
var Preact = __importStar(require("preact"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var Accordion_1 = __importDefault(require("@mui/material/Accordion"));
var ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
var AccordionSummary_1 = __importDefault(require("@mui/material/AccordionSummary"));
var AccordionDetails_1 = __importDefault(require("@mui/material/AccordionDetails"));
var Component = function (p) {
    return (Preact.h(Accordion_1.default, { sx: {
            backgroundColor: 'background.default',
            '&:before': {
                display: 'none',
            },
        }, disableGutters: true, defaultExpanded: true },
        Preact.h(AccordionSummary_1.default, { expandIcon: Preact.h(ExpandMore_1.default, { htmlColor: "black" }), sx: {
                padding: '16px',
                '& .MuiAccordionSummary-content': { alignItems: 'center', margin: 0 },
            } },
            p.labelIcon,
            Preact.h(Typography_1.default, { variant: "h5", sx: { marginLeft: '8px' } }, p.labelText)),
        Preact.h(AccordionDetails_1.default, { sx: { paddingX: 0 } }, p.children)));
};
exports.Component = Component;
